import React from 'react';
import PropTypes from 'prop-types';
import { paymentShape } from 'constants/propTypes';
import { codes, REFUND_ACTION } from 'constants/payment';
import { CardReferenceContent, CardReferenceLink } from './CardReference.styles';
import { FormattedMessage } from 'react-intl';

const CardReference = ({ payment: { method, action, externalReference, membershipNumber }, onPaymentLinkClick }) => {
  if (method === codes.LOYALTY_POINTS) {
    return <CardReferenceContent>{membershipNumber ?? ''}</CardReferenceContent>;
  }

  if (method === codes.BLUE_VOUCHER) {
    return (
      <CardReferenceContent>
        {externalReference ?? ''} &nbsp;
        <FormattedMessage id="paymentsSummary.dependants" />
      </CardReferenceContent>
    );
  }

  if (method === codes.SOCIAL_MEDIA && action !== REFUND_ACTION && externalReference) {
    return <CardReferenceLink onClick={() => onPaymentLinkClick(externalReference)}>{externalReference}</CardReferenceLink>;
  }

  return <CardReferenceContent>{externalReference}</CardReferenceContent>;
};

CardReference.propTypes = {
  payment: paymentShape,
  onPaymentLinkClick: PropTypes.func
};

export default CardReference;
